var $ = jQuery;


$( document ).ready( function () {
	if ( $( ".owl-carousel.offer-carousel" ).length > 0 ) {
		$( ".owl-carousel.offer-carousel" ).owlCarousel( {
			startPosition: 2,
			dots: true,
			loop: true,
			responsive: {
				0: {
					items: 1,
					nav: false,
					margin: 14,
					autoWidth: true,
				},
				768: {
					items: 3,
					nav: true,
					center: true,
					mouseDrag: false,
					touchDrag: false,
				},
				1024: {
					items: 5,
					nav: true,
					center: true,
					mouseDrag: false,
					touchDrag: false,
				},
			},
			onInitialized: callback,
			onResized: callback,
			onTranslated: callback,
		} );
	}

	if ( $( window ).width() < 768 ) {
		setWrapperWidth( '.carousel-section' );
	}

	if ( $( ".owl-carousel.kb-posts-carousel" ).length > 0 && $( window ).width() > 781 ) {
		$( ".owl-carousel.kb-posts-carousel" ).owlCarousel( {
			items: 1,
			nav: true,
			loop: false,
		} );
	}
} );

const addClassToFirstActive = () => {

	const carousel = document.querySelector( '.owl-carousel' );

	if ( ! carousel ) {
		return;
	}

	if ( window.innerWidth > 767 ) {
		return;
	}

	const activeItems = carousel.querySelectorAll( '.owl-item.active' );

	activeItems.forEach( ( item, index ) => {
		item.classList.remove( 'first' );

		if ( index === 0 ) {
			item.classList.add( 'first' );
		}
	} )
}

/**
 * Enables aligning slider to screen on one side and to container on other side
 *
 * @param {string} selector Wrapper element
 */
export const setWrapperWidth = ( selector ) => {

	const wrapper = document.querySelector( selector );

	if ( ! wrapper ) {
		return;
	}

	const innerWidth = window.innerWidth;
	const containerWidth = 380;
	const widthToAdd = (innerWidth - containerWidth) / 2;

	wrapper.style.maxWidth = `${containerWidth + widthToAdd}px`;

}

const callback = () => {
	addClassToFirstActive();
}
